<script>
  import { fade } from 'svelte/transition';
  import UserStore from '../stores/user';
  import fetchData from '../api.js';
  import {link, push} from 'svelte-spa-router'
  import { locale, _ } from 'svelte-i18n';
  import { onMount } from 'svelte';
  import { storeNames } from '../variables';
  import Header from '../components/Header.svelte'; 
  import Preloader from '../components/Preloader.svelte';
  let isLoading = true;
  
  let stores = [];
  

  onMount(async() => {

    if (!$UserStore || !$UserStore.data){
      push('/login');
      return;
    }

    const wms = JSON.parse($UserStore.wms);

    console.log(wms.allowed_stores)

    stores = localStorage.getItem('stores');

    if (stores!='') {

      stores = JSON.parse(stores);
      if (Object.keys(stores).length==0) {

        

        const formData = {
            list : wms.allowed_stores,            
            action : 'get_stores_list',
            token : $UserStore.data
        }

        let data = await fetchData(formData);
        stores = data.data

        localStorage.setItem('stores',JSON.stringify(stores));   


      }
    }

    isLoading = false;
    


  

  });


</script>

<style>
.store {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding:8px 20px 7px;
  border-bottom:1px solid #f1f1f1;
  text-decoration: none;
}
.page-title {
  background: #000;
  color: #fff;
  padding: 10px
}
</style>
<Preloader isLoading={isLoading} />
<Header hide_back="true"/>
<div class="page" transition:fade={{ delay: 250, duration: 300 }}>
  <div class="page-title title">{$_('stores.list')}</div>   
  <div class="stores">
  {#each stores as store}
    <a href="/store/{store.store}" use:link class="store">
      <span>{storeNames[store.store]}</span>
      <i class="fa-solid fa-arrow-left"></i>      
    </a>
  {/each}
  </div>
</div>
